enum TYPE_POINT_CARTE {
  PEI = "PEI",
  PEI_PROJET = "PEI_PROJET",
  DEBIT_SIMULTANE = "DEBIT_SIMULTANE",
}
export default TYPE_POINT_CARTE;
